import { useEffect, useState } from "react";
import Products from "./Sections/Products";

import Box from "@mui/material/Box";
import { getShoppingCartData } from "utils/LaravelApi/LaravelAPI";
import { convertShoppingCartStringToArray } from "helpers/ShoppingCartFunctions";
import ShoppingCart from "./Sections/ShoppingCart";
import FormularioSection from "./Sections/Formulario";
import Pago from "./Sections/Pago";

export default function NewCarritoDeCompra() {

	const [items, setItems] = useState([]);
	const [price, setPrice] = useState(0);
	const [saving, setSaving] = useState(0);
	const [section, setSection] = useState('carritoSection');

	const [formData, setFormData] = useState({
		name: "",
		email: "",
		phone: "",
		street: "",
		postalCode: "",
		colony: "",
		city: "",
		state: "",
		country: "",
		addressReference: "",
	});


	useEffect(() => {
		async function go() {
			const request = await getShoppingCartData();
			const amounts = convertShoppingCartStringToArray();
			if (request.data) {
				const updatedData = request.data.map(item => {
					const amountObject = amounts.find(amountItem => amountItem.id === item.id && amountItem.category === item.category && amountItem.variant === item.variant);
					if (amountObject) {
						return { ...item, amount: amountObject.amount };
					}
					return item;
				});
				setItems(updatedData);
				var price = 0;
				var totalSaving = 0;
				for (var item of updatedData) {
					const current = item.discount ? item.discountPrice : item.price;
					price += item.amount * current;
					if (item.discount) {
						const discount = (item.price - item.discountPrice) * item.amount;
						totalSaving += discount;
					}
				}
				setPrice(price);
				setSaving(totalSaving);
			}
		}
		go();
	}, []);

	if (section === 'carritoSection') {
		return (
			<div>
				<CarritoSection items={items} price={price} saving={saving} updateSection={(section) => setSection(section)} />
			</div>
		);
	}
	else if (section === 'formularioSection') {
		return (
			<div>
				<FormularioSection formData={formData} updateSection={(section) => setSection(section)} setFormData={setFormData} />
			</div>
		);
	}
	else if (section === 'pagoSection') {
		return (
			<div>
				<Pago items={items} price={price} saving={saving} updateSection={setSection} formData={formData} />
			</div>
		);
	}
}

function CarritoSection({ items, price, saving, updateSection }) {

	const container = {
		paddingLeft: "10%",
		paddingRight: "10%",
		paddingTop: "100px",
		minHeight: "60vh",
		fontSize: "40px",
		textAlign: "left",
		marginBottom: "40px",
	};

	const sections = {
		display: "flex",
	};


	return (<Box sx={{ display: { xs: "none", sm: "block" } }} style={container}>
		Carrito de compra
		<hr />
		<Box
			style={sections}
			sx={{ flexDirection: { xs: "column", md: "row" } }}
		>
			<Box
				style={{ width: '60%' }}
			>
				<Products
					items={items}
				/>
			</Box>
			<Box
				style={{ width: '40%' }}
			>
				<ShoppingCart
					allAmounts={items}
					price={price}
					saving={saving}
					updateSection={updateSection}
				/>
			</Box>
		</Box>
	</Box >);
};

